// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1eg9d","errorLogs":"EditorFooter_errorLogs__1flTC"};